import type { BlogPostConfig } from "./types";

export const SKOLKO_STOIT_POST: BlogPostConfig = {
  slug: "skolko-stoit-rasshifrovka-chasa-zapisi",
  metaTitle: "Сколько стоит расшифровка часа записи в 2026 году",
  metaDescription:
    "Реальная цена часа расшифровки: 45 ₽ на Профи и 80 ₽ на Базовом, если выбирать пакет целиком, 150 ₽ при оплате минутами без подписки. За что списываются минуты, что сгорает в конце месяца и сколько на самом деле стоит бесплатный план.",
  title: "Сколько стоит расшифровка часа записи",
  excerpt:
    "Честный расчёт цены часа по всем тарифам: сколько стоит час при полном расходе пакета и сколько — если записей мало. Что сгорает в конце месяца, с какого часа окупается подписка и почему бесплатные планы обходятся дороже платных.",
  category: "Деньги",
  tags: ["стоимость расшифровки", "цена за минуту", "тарифы", "пакеты минут", "расшифровка аудио в текст"],
  datePublished: "2026-09-01",
  dateModified: "2026-09-04",
  readingMinutes: 9,
  content: (
    <>
      <p>
        Короткий ответ: от 40 до 150 ₽ за час — но эта вилка бесполезна без условия, поэтому сразу условие.{" "}
        <strong>Если вы выкупаете пакет минут целиком</strong>, час стоит около 45 ₽ на Профи и около 80 ₽ на Базовом.{" "}
        <strong>Если записей мало</strong>, дешевле платить минутами без подписки — 150 ₽ за час, без ежемесячного
        платежа; это режим, в котором вы оказываетесь после отмены подписки. Пробные 40 ₽ за час существуют только
        внутри 150 минут за 99 ₽ на 7 дней.
      </p>
      <p>
        Разница принципиальная. 80 ₽ за час на Базовом получаются, только если вы за месяц действительно израсходовали
        все 450 минут. Если ушёл один часовой файл, этот час стоил вам 598 ₽ — весь тариф. Поэтому главная статья
        расходов у большинства людей вовсе не цена минуты: это купленная подписка, из которой используют десятую часть,
        и круги по чужим бесплатным планам. Дальше — откуда берутся числа, что сгорает в конце месяца, как не
        переплачивать за длинные записи и с какого объёма подписка вообще имеет смысл.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Цена часа по тарифам</h2>
      <p>
        В Polotno вы покупаете не «расшифровки», а минуты. Поэтому цена часа — это просто цена минуты, умноженная на 60,
        и она падает по мере роста тарифа.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="border border-border px-3 py-2 text-sm">Тариф</th>
              <th className="border border-border px-3 py-2 text-sm">Стоимость</th>
              <th className="border border-border px-3 py-2 text-sm">Минут включено</th>
              <th className="border border-border px-3 py-2 text-sm">Цена минуты</th>
              <th className="border border-border px-3 py-2 text-sm">Час записи</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Пробный, 7 дней</td>
              <td className="border border-border px-3 py-2 text-sm">99 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">150</td>
              <td className="border border-border px-3 py-2 text-sm">0,66 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">≈ 40 ₽</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Базовый, месяц</td>
              <td className="border border-border px-3 py-2 text-sm">598 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">450</td>
              <td className="border border-border px-3 py-2 text-sm">1,33 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">≈ 80 ₽</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Профи, месяц</td>
              <td className="border border-border px-3 py-2 text-sm">1500 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">2000</td>
              <td className="border border-border px-3 py-2 text-sm">0,75 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">≈ 45 ₽</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">
                Без подписки — режим после отмены, пакеты только по полной цене
              </td>
              <td className="border border-border px-3 py-2 text-sm">по факту</td>
              <td className="border border-border px-3 py-2 text-sm">—</td>
              <td className="border border-border px-3 py-2 text-sm">2,5 ₽</td>
              <td className="border border-border px-3 py-2 text-sm">150 ₽</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Если минут внутри месяца не хватило, их докупают пакетами по 100, 500 или 1000 штук, и вот здесь подписка даёт
        главное преимущество: цена минуты в пакете зависит от вашего тарифа. На Базовом это 1,5 ₽, на Профи — 1 ₽, то
        есть 500 минут сверх лимита на Профи стоят 500 ₽, ещё около 8 часов записи.{" "}
        <strong>Без активной подписки пакеты тоже доступны, но по обычной цене 2,5 ₽ за минуту</strong> — льготной
        ставки вне подписки нет.
      </p>
      <p>
        Отдельно про пробный период, чтобы не было сюрпризов. 99 ₽ дают 150 минут на 7 дней — заканчивается тем, что
        наступит раньше. По окончании <strong>пробный период автоматически переходит в Базовый за 598 ₽ в месяц</strong>
        . Если проверили и не подошло, отмените автопродление в личном кабинете до конца недели: вы останетесь на
        поминутной оплате по 2,5 ₽, без ежемесячного платежа. Уже купленные минуты никуда не денутся, но новые пакеты
        будут стоить те же 2,5 ₽ за минуту, а не 1,5 ₽.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Что сгорает, а что переносится</h2>
      <p>
        Минуты, входящие в подписку, действуют внутри оплаченного месяца. При продлении баланс обнуляется и начисляется
        заново: неиспользованные 300 минут на Базовом на следующий месяц не перейдут. Это ровно та причина, по которой
        подписку не стоит брать «на всякий случай».
      </p>
      <p>
        Докупленные пакеты по 100, 500 и 1000 минут ведут себя иначе: они не сгорают ни при продлении, ни при отмене
        подписки — остаются на балансе, пока вы их не израсходуете.
      </p>
      <p>
        Из этих двух правил следует практический вывод для тех, у кого объём скачет. Месяц на 40 минут и месяц на 600 —
        обычная история. На подписке пустой месяц вы теряете, зато в тяжёлый добираете минуты по 1,5 ₽; без подписки не
        теряете ничего, но каждая минута стоит 2,5 ₽ и в пиковый месяц вы заплатите заметно больше. Считать надо не по
        лучшему месяцу и не по худшему, а по среднему за квартал.
      </p>
      <p>
        Что не тарифицируется отдельно: автосводка после расшифровки, разделение по спикерам, таймкоды, выгрузка в TXT,
        DOCX, SRT и режим «Качество» — минуты за них те же самые, доплаты за формат или режим нет. Отдельная квота есть
        только у вопросов в чате по расшифровке. А вот повторная загрузка того же файла — это новая расшифровка, и
        минуты за неё спишутся заново. Цены в таблице конечные, других списаний нет; если нужен счёт на юрлицо, напишите
        в поддержку.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Как не платить за лишние минуты</h2>
      <p>
        Самый простой способ сэкономить заметные деньги — не загружать то, что вам не нужно. Если у вас двухчасовой
        вебинар, из которого нужен только блок вопросов в конце, вырежьте этот блок любым бесплатным редактором и
        загрузите двадцать минут вместо ста двадцати. Разница — сотня минут баланса, то есть примерно четверть месячного
        лимита Базового тарифа.
      </p>
      <p>
        Так же работает и загрузка по ссылке на YouTube, VK Video или Rutube: списывается вся длительность ролика, а не
        интересующий вас фрагмент. Ссылка удобнее, но за удобство вы платите минутами.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">«Вручную» — это не альтернатива</h2>
      <p>
        Почти в любой статье про цену расшифровки вы найдёте расчёт вида «час записи — это 4–6 часов ручной работы,
        считайте сами, сколько стоит ваше время». Расчёт красивый и для этой страницы бесполезный. Люди, набирающие
        текст руками, никуда не делись — стенографисты, студенты, редакции с особыми требованиями. Но человек, который
        ищет, сколько стоит расшифровка часа, уже не выбирает между сервисом и собственной клавиатурой. Он выбирает
        между несколькими сервисами — и, скорее всего, уже перепробовал парочку.
      </p>
      <p>
        Ручной набор остался ровно в двух местах: там, где расшифровку делает профессионал под юридическую
        ответственность (это платная услуга, и стоит она соответственно), и там, где запись такого качества, что никакая
        модель её не берёт. Всё остальное — риторическая фигура для раздувания текста, и мы её здесь не используем.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Сколько на самом деле стоит бесплатное</h2>
      <p>
        Типичный сценарий выглядит так. Человеку нужно расшифровать три часа интервью. Он находит сервис с бесплатным
        планом, регистрируется, загружает файл — и упирается в лимит. Идёт в следующий, регистрируется, загружает,
        упирается. И так по кругу, пока не соберёт три куска текста в трёх разных форматах, из разных интерфейсов, с
        разной разметкой спикеров.
      </p>
      <p>
        Бесплатные планы для этого и сконструированы. Проверено на официальных страницах тарифов в сентябре 2026 года:
      </p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          <strong>Otter.ai</strong> — 300 минут в месяц звучит щедро, но не длиннее 30 минут на встречу и всего{" "}
          <strong>три импорта файла за всю жизнь аккаунта</strong>. Готовую запись вы загрузите три раза, и всё.
        </li>
        <li>
          <strong>Notta</strong> — 120 минут в месяц при лимите 3 минуты на одну запись. Ни одна реальная встреча в три
          минуты не помещается.
        </li>
        <li>
          <strong>Descript</strong> — 1 час медиа в месяц.
        </li>
        <li>
          <strong>Happy Scribe</strong> — пробник на 10 минут. <strong>Sonix</strong> — 30 минут. <strong>Rev</strong> —
          45 минут в месяц автоматической расшифровки.
        </li>
      </ol>
      <p>
        Сложите: пять регистраций, пять паролей, пять разных форматов выгрузки и три часа, которые всё равно не
        расшифрованы целиком. Плюс отдельно выясняется, что заплатить ни одному из них российской картой нельзя. Час
        такой прогулки стоит дороже, чем весь месячный Базовый тариф, — просто счёт приходит не деньгами.
      </p>
      <p>
        Раз уж речь про деньги, два честных якоря для сравнения. Разовая расшифровка без подписки: у Sonix около $10 за
        час, у нас 150 ₽. Расшифровка живым человеком у Rev — около $120 за час, здесь мы не конкурент вообще. На
        подписках у зарубежных сервисов эффективный час тоже дешевеет с объёмом, ровно как у нас, — так что «у них
        дорого, у нас дёшево» было бы тем же трюком, за который мы ругаем чужие подборки. Разница не в цене минуты, а в
        том, что их подписку нельзя оплатить российской картой.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Почему у нас нет бесплатного плана</h2>
      <p>
        Здесь мы обязаны быть последовательными. Мы только что объяснили, почему бесплатные планы бесполезны, — значит,
        надо объяснить и своё решение их не делать.
      </p>
      <p>
        Каждая минута распознавания стоит денег — это чужие серверы и вычисления, и счёт приходит сразу, в момент
        обработки. Сервис, раздающий безлимит даром, покрывает эти расходы либо из инвесторских денег, либо из кармана
        основателя. И то и другое рано или поздно кончается — обычно вместе с самим сервисом, а значит, и с вашим
        архивом расшифровок.
      </p>
      <p>
        99 ₽ за 150 минут — это не «бесплатный сыр в новой упаковке». Это два с половиной часа полноценной работы, без
        трёхминутных огрызков и без лимита на количество файлов, за сумму, которую не жалко потерять, если не подойдёт.
        Проверять качество распознавания надо на своей записи целиком, а не на отрывке, — иначе проверка ничего не
        значит.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Как выбрать тариф</h2>
      <p>
        Считать тут просто. Поминутная оплата — 150 ₽ за час: два часа стоят 300 ₽, три часа — 450 ₽, и это всё ещё
        дешевле Базового за 598 ₽. Базовый выигрывает начиная с четвёртого часа (600 ₽ против 598 ₽), Профи обгоняет
        поминутную ровно с десятого (1500 ₽ против 1500 ₽). Пока вы укладываетесь в 450 минут, Профи вам просто дороже
        Базового: он нужен не «чтобы час стоил 45 ₽», а когда объём стабильно большой.
      </p>
      <p>Отсюда четыре понятных шага, а не четыре равноправные колонки:</p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          <strong>Пробуете 7 дней за 99 ₽.</strong> 150 минут — этого хватает, чтобы прогнать свои настоящие записи, а
          не отрывок.
        </li>
        <li>
          <strong>Зашло и пользуетесь — Базовый.</strong> Это тариф по умолчанию: 450 минут, льготные пакеты по 1,5 ₽,
          если месяц выдался тяжёлый.
        </li>
        <li>
          <strong>Объём большой и стабильный — Профи.</strong> Имеет смысл, когда 7–8 часов в месяц уже не предел, а
          норма.
        </li>
        <li>
          <strong>Нужно раз в квартал — отменяете.</strong> Дальше поминутная оплата 2,5 ₽ за минуту, без ежемесячного
          платежа и без льготных пакетов.
        </li>
      </ol>
      <p>
        Если после пробы сервис зашёл и записи будут не раз в квартал, берите Базовый — он ровно для этой задачи и
        сделан. Но делать вид, что он выгоден всем, мы не станем: при одном часе в месяц он стоит 598 ₽ против 150 ₽
        поминутно, и это считает любой. Клиент, который ушёл довольным, вернётся, когда объём вырастет; клиент, которому
        продали лишнее, не вернётся никогда.
      </p>
    </>
  ),
  faq: [
    {
      question: "Сколько стоит расшифровать час записи в Polotno?",
      answer:
        "Если пакет минут расходуется целиком — около 45 ₽ на Профи и около 80 ₽ на Базовом. Если записей мало, дешевле платить минутами без подписки: 150 ₽ за час. Важная оговорка: 80 ₽ на Базовом получаются только при полном расходе 450 минут; если за месяц ушёл один часовой файл, этот час обошёлся в 598 ₽ — стоимость всего тарифа."
    },
    {
      question: "Минуты списываются за длительность записи или за речь?",
      answer:
        "За длительность файла, с округлением вверх. Часовая запись спишет 60 минут, даже если половину времени все молчали. Поэтому длинные записи, из которых нужен один фрагмент, выгоднее обрезать перед загрузкой."
    },
    {
      question: "Что происходит после окончания пробного периода?",
      answer:
        "Пробный период заканчивается через 7 дней или после 150 минут — что наступит раньше — и автоматически переходит в тариф Базовый за 598 ₽ в месяц. Если сервис не подошёл, отмените автопродление в личном кабинете до окончания недели: вы останетесь на поминутной оплате по 2,5 ₽ без ежемесячного платежа, купленные пакеты минут при этом сохраняются."
    },
    {
      question: "Сгорают ли неиспользованные минуты в конце месяца?",
      answer:
        "Минуты, входящие в подписку, действуют внутри оплаченного месяца: при продлении баланс обнуляется и начисляется заново, неизрасходованный остаток не переносится. Докупленные пакеты по 100, 500 и 1000 минут не сгорают ни при продлении, ни при отмене подписки и остаются на балансе до полного расхода."
    },
    {
      question: "Есть ли доплаты за формат выгрузки, сводку или режим «Качество»?",
      answer:
        "Нет. Разделение по спикерам, таймкоды, автосводка, выгрузка в TXT, DOCX и SRT и режим «Качество» расходуют те же минуты, отдельной платы за них нет. Своя квота есть только у вопросов в чате по расшифровке. Повторная загрузка того же файла считается новой расшифровкой, и минуты за неё списываются заново."
    },
    {
      question: "Можно ли докупить минуты, не меняя тариф?",
      answer:
        "Да, пакетами по 100, 500 или 1000 минут. Цена минуты в пакете зависит от текущей подписки: 1,5 ₽ на Базовом и 1 ₽ на Профи. Без активной подписки пакеты тоже можно купить, но по обычной цене 2,5 ₽ за минуту — льготной ставки вне подписки нет."
    },
    {
      question: "Сколько стоит час у зарубежных сервисов?",
      answer:
        "Разовая расшифровка без подписки у Sonix стоит около $10 за час, час с живым расшифровщиком у Rev — около $120. На подписках эффективная цена часа у зарубежных сервисов тоже падает с объёмом, как и у российских, так что дело не в самой цене минуты: ни один из них не принимает карты российских банков напрямую."
    }
  ],
  relatedPaths: ["/transcription-online", "/mp3-to-text", "/audio-summary", "/meeting-minutes", "/speaker-diarization"]
};
